// Path: /components/Layout/Header.js
"use client";

import React, { useEffect, useState, useRef } from 'react';
import Link from 'next/link';
import Navbar from '/components/Layout/Navbar/Navbar';
import headerStyles from './Header.module.css';

const Header = ({ variant = 'shuffledb', productHref = '/TrackDat' }) => {
  // State to control header auto-hide
  const [hideHeader, setHideHeader] = useState(false);
  const product = variant === 'trackdat'
    ? { name: 'TrackDat', tagline: 'MOTION TRACKING FOR DANCERS.' }
    : variant === 'capdat'
      ? { name: 'CapDat', tagline: 'CAPTURE. MIX. HAND OFF.' }
    : variant === 'postdat'
      ? { name: 'PostDat', tagline: 'PACKAGE. SCHEDULE. PUBLISH.' }
      : variant === 'editdat'
        ? { name: 'EditDat', tagline: 'DIRECT. EDIT. DECIDE.' }
      : null;
  const isProduct = Boolean(product);
  // Ref to keep track of the last scroll position without causing re-renders
  const lastScrollRef = useRef(0);
  // Define threshold (in pixels) required to toggle header visibility
  const threshold = 40;

  useEffect(() => {
    const updateHeaderVisibility = (currentScroll) => {
      // If the user scrolls down more than the threshold, hide the header
      if (currentScroll - lastScrollRef.current > threshold) {
        setHideHeader(true);
        lastScrollRef.current = currentScroll;
      }
      // If the user scrolls up more than the threshold, show the header
      else if (lastScrollRef.current - currentScroll > threshold) {
        setHideHeader(false);
        lastScrollRef.current = currentScroll;
      }
      // Otherwise, do nothing—wait for a significant scroll
    };

    // EVENT LISTENER FOR MOVING HEADER AND NAVBAR ON SCROLLDOWN
    const handleScroll = () => {
      updateHeaderVisibility(window.pageYOffset || document.documentElement.scrollTop);
    };
    const handleProductPaneScroll = (event) => {
      updateHeaderVisibility(Number(event.detail?.scrollTop) || 0);
    };

    window.addEventListener("scroll", handleScroll, false);
    window.addEventListener('shuffledb:product-pane-scroll', handleProductPaneScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener('shuffledb:product-pane-scroll', handleProductPaneScroll);
    };
  }, []);

  return (
    <>
      {/* Header Content */}
      <header className={`${headerStyles.header} ${isProduct ? headerStyles.trackDatHeader : ''} ${hideHeader ? headerStyles.hideHeader : ''}`}>
        <div className={headerStyles.headerContent}>
          <div className={headerStyles.title}>
            {isProduct && (
              <span className={headerStyles.trackDatKicker}>ShuffleDB presents:</span>
            )}
            <Link className={headerStyles.siteName} href={isProduct ? productHref : '/'}>
              <span className={headerStyles.titleText}>{product?.name || 'SHUFFLEDB.COM'}</span>
            </Link>
          </div>
          <div className={headerStyles.subtitle}>
            <span
              className={`${headerStyles.subtitleText} ${isProduct ? headerStyles.trackDatSubtitleSpacer : ''}`}
              aria-hidden={isProduct ? 'true' : undefined}
            >
              {isProduct ? '\u00a0' : 'A definitive crowdsourced collection'}
            </span>
            <span className={headerStyles.highlight}>
              {product?.tagline || 'of shuffle dance moves'}
            </span>
          </div>
        </div>
      </header>

      {/* Include Navbar */}
      <Navbar hideHeader={hideHeader} variant={variant} productHref={productHref} />
    </>
  );
};

export default Header;
